import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';

/**
 * API Client for unverified donations.
 */
@Injectable({
  providedIn: 'root',
})
export class UnverifiedDonationApi {
  private readonly http = inject(HttpClient);

  private httpHeaders = new HttpHeaders({
    'ngsw-bypass': 'true',
  });

  /**
   * Acquires the form for an unverified donation using the given `hash`.
   *
   * @param hash The hash with which the unverified donation is acquired
   */
  get(hash: string): Observable<Record<string, any>> {
    const url = `/api/next/verify/${hash}/`;

    return this.http.get(url, { headers: this.httpHeaders });
  }

  /**
   * Acquires the status of the unverified donation.
   *
   * @param hash The hash with which the unverified donation is acquired
   *
   * @returns
   * An `Observable` that emits with the status of the unverified donation
   */
  getStatus(hash: string): Observable<unknown> {
    const url = `/api/next/verify/${hash}/`;

    return this.http.head(url, { headers: this.httpHeaders });
  }

  /**
   * Uses the prepared data to authenticate for verification.
   *
   * @param preparedData The prepared data
   */
  authenticateForVerification(
    preparedData: Record<string, unknown>,
  ): Observable<Record<string, any>> {
    const url = `/api/next/verify/`;

    return this.http.post(url, preparedData, { headers: this.httpHeaders });
  }

  /**
   * Uses the given data to verify a donation
   *
   * @param data The data which is used to verify the donation
   */
  verifyDonation(
    data: Record<string, unknown>,
  ): Observable<Record<string, any>> {
    const url = `/api/next/verify/`;

    return this.http.post(url, data, { headers: this.httpHeaders });
  }
}
